<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">拜师</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="txt-tip">
      <div class="tip">
        向有经验的玩儿家拜师，师父可以为你答疑解惑，指点迷津，更好的体验到交友的乐趣。
        徒弟同时只能拥有一位师父，师傅根据魅力值等级可以同时接收多名徒弟。
        <br/>
        <br/>
        拜师操作：跟师傅聊天，确定师徒关系，然后在聊天页面发送拜师申请，等待师父确认即可。
      </div>
    </div>

 <li class="pupil-block" v-for="(item, index) in data" :key="index" >
      <div class="pupil ub ub-pc" v-if="item.s_total>30000">
        <img :src="item.photo" class="photo" />
        <div class="ub ub-f1 ub-pc ub-ac2">
          <div class="ub ub-ver ub-f1">
            <div class="ub ub-ac2">
              <span class="sp1">{{ item.nick }}</span>
              <span class="day">注册时长:<label class="la">{{ item.difday }}</label>天</span>
            </div>

            <div class="ub" style="margin-top: 0.6rem">
              <div class="sex-width ub ub-pc">
                <img v-if="item.sex == '女生'" src="../../assets/img/女.png" class="sex-img"/>
                <img v-if="item.sex == '男生'" src="../../assets/img/男.png" class="sex-img"/>
                <span :class="item.sex == '女生' ? 'sex' : 'sex2'">{{item.sex}}</span>
              </div>
              <span class="ub ub-pc day">总魅力值:<label class="la" >{{ item.s_total }}</label ></span>
            </div>
          </div>
          <span class="btn" @click="goto_chat(item.uid)">拜师</span>
        </div>
      </div>
    </li>

    <div class="ub ub-pc ub-ac">
      <div class="ub ub-ac ub-pc btn-more" @click="load_more()"><span>加载更多</span></div>
    </div>
     
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      data: [],
      index: 0,
      size: 10,
      theme_dark: false
    };
  },
  mounted() {
   //切换深色模式
   this.theme_dark = tool.is_theme_dark(this);
   this.load_more();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    load_more() {
       this.$loading('加载...');

      var self = this;
      self.get({
        url:"/App/GetMasterCan/?index=" + self.index + "&size=" + self.size,
        success: function (data) {
          //console.log(JSON.stringify(data))
          self.$loading.close();

          if(data.length <= 0 &&  self.index>0){
            self.$toast.center("没有更多了~");
            return false;
          }

          self.index++;
          
          for (var i = 0; i < data.length; i++) {
            data[i].photo = self.$store.state.url + "/photo/" + data[i].photo;
          }
          self.data = self.data.concat(data);

        },
      });
       
    },
     goto_chat(uid) {
      this.$router.push({ name: "chart", params: { uid: uid } });
    },
    
  },
};
</script>

<style lang="scss" scoped>
.txt-tip {
  padding: .5rem 0.5rem;
  background-color: #fff;
  .tip {
    font-size: 0.9rem;
    border: 1px solid #dcdcdc;
    border-radius: 0.3rem;
    color: #555;
    padding: 0.3rem 0.4rem;
    background-color: #fff;
    line-height: 1.6rem;
  }
}

.pupil-block {
  font-size: 0.85rem;
  background-color: #fff;
  .pupil {
    border-bottom: 1px solid #dcdcdc;
    padding: 1.2rem 0.8rem 1.2rem 0.8rem;
    .photo {
      width: 3.8rem;
      height: 3.8rem;
      border-radius: 50%;
      margin-right: 0.5rem;
    }
    .day {
      margin: 0 0.5rem;
      color: #888;
    }
    .sp1 {
      display: inline-block;
      width: 6rem;
    }
    .sex-width {
      width: 6rem;
      color: #ff3ec9;
      .sex-img {
        width: 1.25rem;
      }
      .sex {
        color: #ff3ec9;
      }
      .sex2 {
        color: #37b8d5;
      }
    }
    .la {
      margin: 0 0.15rem;
      color: #333;
      font-weight: bold;
      font-size: 0.9rem;
    }
    .btn {
      border: 1px solid #e92162;
      padding: 0.3rem 1rem;
      border-radius: 0.3rem;
      color: #e92162;
    }
  }
}

.btn-more {
  margin: 1rem 0;
  padding: 0.5rem 8rem;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  span {
    font-size: 0.9rem;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .txt-tip {
    background-color: #2F2E33;
    .tip {
      color: #888;
      background-color: #2c2b30;
      border: 1px solid #888;
    }
  }
  .pupil-block {
    background-color: #2F2E33;
    .pupil {
      border-bottom: 1px solid #404040;
      .sp1 {
        color: #FDFDFD;
      }
      .day {
        .la {
          color: #FDFDFD;
        }
      }
    }
  }
}
</style>